import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { CreateRuleExclusionDialog } from '../../../components/attack-events-grid/actions/create-rule-exclusion-dialog'
import { AgentLanguage } from '../../../components/agent-language'
import { UserInputType } from '../../../components/attack-events-grid/shared'

export interface BridgeProps {
  organizationUuid: string
  isOpen: boolean
  attackEvent: {
    eventUuid: string
    sourceIP: string
    url: string
    userInput: {
      name: string
      type: UserInputType
    }
    ruleUuid: string
    application: {
      id: string
      name: string
      language: string
    }
  }
  onClose: () => void
  onExclusionAdded: (eventUuid: string, eventsSuppressed?: number) => void
}

export function Bridge({
  organizationUuid,
  isOpen,
  attackEvent,
  onClose,
  onExclusionAdded
}: BridgeProps) {
  if (!attackEvent) {
    return <></>
  }

  const {
    eventUuid,
    sourceIP,
    url,
    userInput,
    ruleUuid,
    application: { id: applicationID, name: applicationName, language }
  } = attackEvent

  return (
    <CreateRuleExclusionDialog
      organizationUuid={organizationUuid}
      isOpen={isOpen}
      attackEvent={{
        uuid: eventUuid,
        sourceIP,
        url,
        userInput,
        ruleUuid
      }}
      application={{
        id: applicationID,
        name: applicationName,
        language: AgentLanguage.fromValue(language).getValue()
      }}
      closeDialog={onClose}
      onExclusionAdded={onExclusionAdded}
    />
  )
}

export const reactAddExclusionAction = createNgReactBridgeDirective(
  'reactAddExclusionAction',
  [],
  Bridge,
  ['organizationUuid', 'isOpen', 'attackEvent', 'onClose', 'onExclusionAdded']
)
